/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Partner_Details_SubtitleInputs */



/**
* | output |
* | --- |
* | "Information about the partner managing this organization." |
*
* @param {Sub_Partner_Details_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_partner_details_subtitle = /** @type {((inputs?: Sub_Partner_Details_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Partner_Details_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Informationen über den Partner, der diese Organisation verwaltet.")
	return /** @type {LocalizedString} */ ("Information about the partner managing this organization.")
});